function is_sheba_resalat(value) {
  return value.startsWith('70', 3);
}

export default is_sheba_resalat;
